import React from 'react';

import { useFlag } from 'utils/featureFlagsAndMetrics';
import { getProductCategoriesContent } from '../../content';
import { ProductCategory } from './components';
import { NestedLinksContainer } from './ProductLinks.style';

interface ProductLinksProps {
  isOpen?: boolean;
  setIsModalOpen?: (value: boolean) => void;
  isMobile?: boolean;
}

export const ProductLinks = ({
  isOpen = true,
  setIsModalOpen,
  isMobile = false,
}: ProductLinksProps) => {
  const isCelebrityLaunchEnabled = Boolean(
    useFlag<boolean | undefined>('curology-celebrity-launch'),
  );
  const categories = getProductCategoriesContent(isCelebrityLaunchEnabled);

  return (
    <NestedLinksContainer>
      {categories.map((category) => (
        <ProductCategory
          key={category.category}
          content={category}
          isOpen={isOpen}
          setIsModalOpen={setIsModalOpen}
          isMobile={isMobile}
        />
      ))}
    </NestedLinksContainer>
  );
};
